
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import { validationRules } from "@/constants/ValidationRules";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextField from "@/components/common/TextField.vue";
import {scheduleService} from "@/app/services/schedule.service";
import FormComponentExternalEntityBase from "@/app/dynamic-components/forms/form-components/form-component-ext-entity.base";
import {Schedule} from "@/app/models/schedule/schedule.model";
import {RenderItem} from "@/app/Types";
import store from "@/store";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";
import {configManager} from "@/app/services/config.manager";

export type ScheduleMetaData = {
  blockType: string
  startDate: string
  endDate: string
  toState: string //move the schedule to a specific state if possible active pending cancelled
  blockSchedule: boolean //actually set the person as unavailable
  regardingId: string
  regardingType: string
  referenceId: string
  contactId: string
  organizationId: string
};

@Component({
  components: {DynamicComponentConfigManager},
})
export default class FormComponentSchedule extends FormComponentExternalEntityBase<ScheduleMetaData, Schedule | Schedule[]> {

  configManager() {
    return configManager
  }

  protected async fetchExternalEntity(value: any): Promise<Schedule | Schedule[] | null> {
    if(!value){
      return null;
    }
    const schedules: Schedule[] = [];
    if(typeof value === 'string'){
      const ids = value.split(',');
      for (let i = 0; i < ids.length; i++) {
        const schedule = await scheduleService.getSchedule(ids[i])
        if(schedule)
          schedules.push(schedule);
      }
    }
    if(schedules.length === 1) return schedules[0];
    return schedules;
  }

  private creationIds: {[key: string]: string} = {};
  protected async createExternalEntity(formData: any): Promise<string> {
    const meta = this.entry.root?.resolvePlaceholders(this.entry.metadata);
    let startDate = meta.startDate && meta.startDate.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.startDate) : meta.startDate;
    startDate = meta.startDate && meta.startDate === 'now' ? new Date().toISOString() : startDate;
    let endDate = meta.endDate && meta.endDate.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.endDate) : meta.endDate;
    endDate = meta.endDate && meta.endDate === 'now' ? new Date().toISOString() : endDate;
    let contactIds = meta.contactId && meta.contactId.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.contactId) : meta.contactId;
    const organizationId = meta.organizationId && meta.organizationId.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.organizationId) : meta.organizationId;
    const referenceId = meta.referenceId && meta.referenceId.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.referenceId) : meta.referenceId;
    const regardingType = meta.regardingType && meta.regardingType.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.regardingType) : meta.regardingType;
    if(startDate === '$nan') startDate = null;
    if(endDate === '$nan') endDate = null;
    if(typeof contactIds === 'string'){
      contactIds = [contactIds];
    }



    this.creationIds = {};
    for (const contactId of contactIds) {
      const scheduleId = await scheduleService.createSchedule({
        activityId: store.state.activity.currentActivityDefinition.id,
        startDate: startDate,
        endDate: endDate,
        description: '',
        state: 'pending', //active
        blockTime: meta.blockSchedule,
        blockType: meta.blockType,
        contactId: contactId,
        organizationId: organizationId,
        referenceId: referenceId,
        regardingType: regardingType
      });
      this.creationIds[contactId] = scheduleId;
    }

    return Object.values(this.creationIds).join(',');
  }

  protected async updateExternalEntity(externalEntityId: string, externalEntity: Schedule | Schedule[] | null, formData: any): Promise<void> {
    if(!externalEntity ) return Promise.reject();

    const meta = this.entry.root?.resolvePlaceholders(this.entry.metadata);
    let toState = meta.toState && meta.toState.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.toState) : meta.toState;
    let startDate = meta.startDate && meta.startDate.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.startDate) : meta.startDate;
    startDate = meta.startDate && meta.startDate === 'now' ? new Date().toISOString() : startDate;
    let endDate = meta.endDate && meta.endDate.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.endDate) : meta.endDate;
    endDate = meta.endDate && meta.endDate === 'now' ? new Date().toISOString() : endDate;
    if(startDate === '$nan') startDate = null;
    if(endDate === '$nan') endDate = null;
    if(toState && (toState !== 'active' || toState !== 'pending' || toState !==  'cancelled')){
      toState = 'active'
    }

    const schedules = externalEntityId.split(',');
    for (const scheduleId of schedules) {
      let schedule: Schedule | undefined = undefined;
      if(Array.isArray(externalEntity)){
        const list = externalEntity.filter(value => value.id === scheduleId);
        schedule = list.length > 0 ? list[0] : externalEntity[0];
      }else{
        schedule = externalEntity;
      }
      await scheduleService.updateSchedule(scheduleId, {
        activityId: schedule.activityId,
        startDate: startDate,
        endDate: endDate,
        description: schedule.description,
        state: toState || schedule.state,
        blockTime: meta.blockTime,
        blockType: meta.blockType,
        contactId: schedule.contactId,
        organizationId: schedule.organizationId,
        referenceId: schedule.referenceId,
        regardingType: schedule.regardingType,
        regardingId: schedule.regardingType ? schedule.regardingId : undefined
      });
    }
    return Promise.resolve();
  }


  protected async createExternalEntityAfterSave(sumbitData: any): Promise<void> {
    if(!this.creationIds || Object.keys(this.creationIds).length <=0) return;

    //link to other entity needs to happen after safe + status to active to active the active the schedule

    const meta = this.entry.root?.resolvePlaceholders(this.entry.metadata);
    let toState = meta.toState && meta.toState.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.toState) : meta.toState;
    let startDate = meta.startDate && meta.startDate.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.startDate) : meta.startDate;
    startDate = meta.startDate && meta.startDate === 'now' ? new Date().toISOString() : startDate;
    let endDate = meta.endDate && meta.endDate.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.endDate) : meta.endDate;
    endDate = meta.endDate && meta.endDate === 'now' ? new Date().toISOString() : endDate;
    let contactIds = meta.contactId && meta.contactId.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.contactId) : meta.contactId;
    const organizationId = meta.organizationId && meta.organizationId.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.organizationId) : meta.organizationId;
    const referenceId = meta.referenceId && meta.referenceId.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.referenceId) : meta.referenceId;
    const regardingType = meta.regardingType && meta.regardingType.startsWith('data.') ? this.entry.root?.resolveFieldValue(meta.regardingType) : meta.regardingType;
    if(startDate === '$nan') startDate = null;
    if(endDate === '$nan') endDate = null;
    if(typeof contactIds === 'string'){
      contactIds = [contactIds];
    }
    if(toState && (toState !== 'active' || toState !== 'pending' || toState !==  'cancelled')){
      toState = 'active'
    }

    for (const contactId of contactIds) {
      const scheduleId = this.creationIds[contactId];
      await scheduleService.updateSchedule(scheduleId, {
        activityId: store.state.activity.currentActivityDefinition.id,
        startDate: startDate,
        endDate: endDate,
        description: '',
        state: toState? toState : 'active', //active
        blockTime: meta.blockTime,
        blockType: meta.blockType,
        contactId: contactId,
        organizationId: organizationId,
        referenceId: referenceId,
        regardingType: regardingType,
        regardingId: sumbitData?.referenceId.split(',')[0] || null
      });
    }

    this.creationIds = {};
    return Promise.resolve();
  }
}
